import {
    FETCH_OPERATOR_STATS_BY_COMPANIES_BEGIN,
    FETCH_OPERATOR_STATS_BY_COMPANIES_ERROR,
    FETCH_OPERATOR_STATS_BY_COMPANIES_SUCCESS,
    FETCH_OPERATOR_STATS_BY_SALES_POINTS_BEGIN,
    FETCH_OPERATOR_STATS_BY_SALES_POINTS_ERROR,
    FETCH_OPERATOR_STATS_BY_SALES_POINTS_SUCCESS,
    FETCH_OPERATOR_TOTAL_STATS_BEGIN,
    FETCH_OPERATOR_TOTAL_STATS_ERROR,
    FETCH_OPERATOR_TOTAL_STATS_SUCCESS
} from "../actions/operatorStatsActions";


const defaultOperatorStatsState = {
    operatorStats: [],
    loading: false,
    pagination: {
        numberOfElements: 0,
        totalElements: 0,
        totalPages: 0
    },
};

export const operatorStatsByCompaniesReducer = (state = defaultOperatorStatsState, action) => {
    switch (action.type) {
        case FETCH_OPERATOR_STATS_BY_COMPANIES_BEGIN:
            return {
                ...state,
                loading: true,
            };

        case FETCH_OPERATOR_STATS_BY_COMPANIES_SUCCESS:
            return {
                ...state,
                loading: false,
                operatorStats: action.payload.operatorStats,
                pagination: {
                    numberOfElements: action.payload.numberOfElements,
                    totalElements: action.payload.totalElements,
                    totalPages: action.payload.totalPages
                },
            };

        case FETCH_OPERATOR_STATS_BY_COMPANIES_ERROR:
            return {
                ...state,
                loading: false,
                operatorStats: []
            };

        default:
            return state;
    }
};

export const operatorStatsBySalesPointsReducer = (state = defaultOperatorStatsState, action) => {
    switch (action.type) {
        case FETCH_OPERATOR_STATS_BY_SALES_POINTS_BEGIN:
            return {
                ...state,
                loading: true,
            };

        case FETCH_OPERATOR_STATS_BY_SALES_POINTS_SUCCESS:
            return {
                ...state,
                loading: false,
                operatorStats: action.payload.operatorStats,
                pagination: {
                    numberOfElements: action.payload.numberOfElements,
                    totalElements: action.payload.totalElements,
                    totalPages: action.payload.totalPages
                },
            };

        case FETCH_OPERATOR_STATS_BY_SALES_POINTS_ERROR:
            return {
                ...state,
                loading: false,
                operatorStats: []
            };

        default:
            return state;
    }
};

export const operatorTotalStatsReducer = (state = defaultOperatorStatsState, action) => {
    switch (action.type) {
        case FETCH_OPERATOR_TOTAL_STATS_BEGIN:
            return {
                ...state,
                loading: true,
            };

        case FETCH_OPERATOR_TOTAL_STATS_SUCCESS:
            return {
                ...state,
                loading: false,
                operatorStats: action.payload.operatorStats,
                pagination: {
                    numberOfElements: action.payload.numberOfElements,
                    totalElements: action.payload.totalElements,
                    totalPages: action.payload.totalPages
                },
            };

        case FETCH_OPERATOR_TOTAL_STATS_ERROR:
            return {
                ...state,
                loading: false,
                operatorStats: []
            };

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/operatorStats.js